import ApiService from "./apiServices";
import { isLatestRequest, startRequest } from "./latestRequest";

export const fetchListData = ({
  apiUrl,
  pageKey,
  filterData,
  filterProcessor,
  rawFilter = false,
  page,
  rowPerPage,
  sortField,
  sortDirection,
  sortFieldParam = "sortField",
  buildUrl,
  alert_notify,
  onSuccess,
  onError,
}) => {
  const scope = `list:${apiUrl || "url"}:${pageKey || "page"}`;
  const requestId = startRequest(scope);

  try {
    let url;

    if (buildUrl) {
      url = buildUrl({ apiUrl, page, rowPerPage, sortField, sortDirection });
    } else {
      url = `${apiUrl}?page=${page + 1}&pageLimit=${rowPerPage}`;

      let effectiveFilter = null;
      if (filterData) {
        effectiveFilter = filterData;
      } else if (pageKey) {
        const searchFilterData = JSON.parse(localStorage.getItem("searchFilterData") || "null");
        effectiveFilter = searchFilterData?.[pageKey] || null;
      }

      if (effectiveFilter) {
        const entries = filterProcessor ? filterProcessor(effectiveFilter) : Object.entries(effectiveFilter);
        entries.forEach(([key, value]) => {
          if (rawFilter) {
            if (value) url += `&${key}=${value}`;
          } else if (value !== undefined && value !== null && value !== "") {
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        });
      }

      if (sortField) url += `&${sortFieldParam}=${encodeURIComponent(sortField)}`;
      if (sortDirection) url += `&sortOrder=${encodeURIComponent(sortDirection)}`;
    }

    return new Promise((resolve, reject) => {
      ApiService.get(url, resolve, reject, true);
    })
      .then((response) => {
        if (!isLatestRequest(scope, requestId)) return;
        return onSuccess(response);
      })
      .catch((err) => {
        if (!isLatestRequest(scope, requestId)) return;
        if (onError) onError(err);
        else alert_notify("error", err?.message);
      });
  } catch (e) {
    if (onError) onError(e);
    else alert_notify("error", e?.message);
  }
};
